import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list-arrow",
  "use": "list-arrow-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"list-arrow\"><path d=\"M8.099 5.762a.336.336 0 00.237.573h2.546v6.547a1.119 1.119 0 002.236 0V6.335h2.546a.336.336 0 00.237-.573l-3.664-3.664a.336.336 0 00-.474 0L8.099 5.762zM.5 3a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 3a.5.5 0 000 1h5a.5.5 0 000-1h-5zM0 9.5A.5.5 0 01.5 9h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zM.5 12a.5.5 0 000 1h5a.5.5 0 000-1h-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol